<template>
  <!--
          作者：luoyiming
          时间：2019-10-25
          描述：商户-商户管理
      -->
  <div class="user clearfix">

    <!--添加商户-->
    <div class="common-level-rail fl">
      <el-button size="small" type="primary" icon="el-icon-plus" @click="addClick"
        v-auth="'/supplier/supplier/add'">添加商户</el-button>
    </div>
    <div class="common-seach-wrap fr">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="商户">
          <el-input v-model="formInline.search" placeholder="请输入商户名称"></el-input>
        </el-form-item>

        <el-form-item label="城市">
          <el-select size="small" v-model="formInline.serviceCityId" placeholder="所有分类">
            <el-option label="全部" value="0"></el-option>
            <el-option v-for="(item, index) in data" :key="index" :label="item.city"
              :value="item.city_id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="shopSupplierId" align="center" label="商户ID" width="100"></el-table-column>
          <el-table-column prop="name" align="center" label="商户名称"></el-table-column>
          <el-table-column prop="userName" align="center" label="登录账号"></el-table-column>
          <el-table-column label="logo" align="center" width="120">
            <template slot-scope="scope">
              <el-image v-if="scope.row.logo" :src="scope.row.logo.file_url" width="50" height="50"
                :preview-src-list="getLogoList(scope.$index)" />
            </template>
          </el-table-column>
          <el-table-column label="营业执照" align="center" width="120">
            <template slot-scope="scope">
              <el-image v-if="scope.row.business" :src="scope.row.business.file_url" width="50" height="50"
                :preview-src-list="getBusinessList(scope.$index)" />
            </template>
          </el-table-column>
          <el-table-column prop="scale" align="center" label="抽成比例"></el-table-column>
          <!-- <el-table-column label="保证金" align="center" width="120">
            <template slot-scope="scope">
              <span v-if="scope.row.status == 0" class="green">已缴纳</span>
              <span v-if="scope.row.status == 10">申请退出</span>
              <span v-if="scope.row.status == 20" class="gray">未缴纳</span>
            </template>
          </el-table-column> -->
          <el-table-column label="城市" align="center" width="120" prop="service_city.city">
          </el-table-column>
          
          <el-table-column prop="linkName" align="center" label="联系人" width="150"></el-table-column>
          <el-table-column prop="linkPhone" align="center" label="联系电话" width="120"></el-table-column>
          <el-table-column prop="address" align="center" label="联系地址"  width="300"></el-table-column>
          <el-table-column prop="createTime" align="center" label="添加时间" width="150"></el-table-column>
          <el-table-column fixed="right" align="center" label="操作" width="220">
            <template slot-scope="scope">
              <el-button @click="recycle(scope.row, 0)" type="success" size="small" v-auth="'/supplier/supplier/edit'"
                v-if="scope.row.is_recycle == 1" style="color:gray;">开启</el-button>
              <el-button @click="recycle(scope.row, 1)" type="info" size="small" v-auth="'/supplier/supplier/edit'"
                v-else>禁用</el-button>
              <el-button @click="editClick(scope.row)" type="primary" size="small"
                v-auth="'/supplier/supplier/edit'">编辑</el-button>
              <el-button @click="deleteClick(scope.row.shopSupplierId)" type="danger" size="small"
                v-auth="'/supplier/supplier/delete'">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
          :current-page="curPage" :page-size="pageSize" layout="total, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>

  </div>
</template>

<script>
import SupplierApi from "@/api/supplier.js";
export default {
  components: {},
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*门店列表数据*/
      storeList: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      formInline: {
        shop_id: "",
        search: "",
        serviceCityId: ""
      },
      data: [],
      /*是否打开添加弹窗*/
      open_add: false,
      /*是否打开编辑弹窗*/
      open_edit: false,
      /*当前编辑的对象*/
      userModel: {},
      logoImgs: [],
      businessImgs: []
    };
  },
  created() {
    /*获取列表*/
    this.getTableList();
  },
  methods: {
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.loading = true;
      self.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = {};
      Params.pageIndex = self.curPage;
      Params.pageSize = self.pageSize;
      Params.name = self.formInline.search;
      Params.serviceCityId = self.formInline.serviceCityId;
      SupplierApi.supplierList(Params, true)
        .then(res => {
          console.log(res,'res.data.list.total')
          self.loading = false;
          self.tableData = res.data.list.records;
          self.data = res.data.data;
          self.totalDataNumber = res.data.list.total;
          self.tableData.forEach(function (item) {
            if (item.business) {
              self.businessImgs.push(item.business.filePath);
            }
            if (item.logo) {
              self.logoImgs.push(item.logo.filePath);
            }
          });
        })
        .catch(error => {
          self.loading = false;
        });
    },
    getLogoList(index) {
      return this.logoImgs.slice(index).concat(this.logoImgs.slice(0, index));
    },
    getBusinessList(index) {
      return this.businessImgs
        .slice(index)
        .concat(this.businessImgs.slice(0, index));
    },
    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.getTableList();
    },

    /*打开添加*/
    addClick() {
      this.$router.push("/supplier/supplier/add");
    },

    /*打开编辑*/
    editClick(row) {
      let self = this;
      let params = row.shopSupplierId;
      this.$router.push({
        path: "/supplier/supplier/edit",
        query: {
          shopSupplierId: params
        }
      });
    },
    /* 强制下架上架*/
    recycle(row, state) {
      let self = this;
      let war = "";
      if (state == 1) {
        war = "禁止";
      } else if (state == 0) {
        war = "开启";
      }
      self
        .$confirm("确认要" + war + "吗?", "提示", {
          type: "warning"
        })
        .then(() => {
          SupplierApi.supplierRecycle({
            shopSupplierId: row.shopSupplierId,
            is_recycle: state
          }).then(data => {
            self.$message({
              message: war + "成功",
              type: "success"
            });
            self.getTableList();
          });
        });
    },
    /*删除*/
    deleteClick(row) {
      let self = this;
      self
        .$confirm("删除商户，商户下的相关技师也会被删除, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          self.loading = true;
          SupplierApi.deleteSupplier(
            {
              shopSupplierId: row
            },
            true
          )
            .then(data => {
              self.loading = false;
              if (data.code == 1) {
                self.$message({
                  message: "恭喜你，商户删除成功",
                  type: "success"
                });
                self.getTableList();
              }
            })
            .catch(error => {
              self.loading = false;
            });
        })
        .catch(() => {
          self.loading = false;
        });
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/supplier/supplier/index.vue